export const featureSlugs = {
  FORMS: 'forms',
  SUBMISSIONS: 'submissions',
  TRUSTEDFORM: 'trustedform',
  MULTIPLE_ENDINGS: 'multiple_endings',
  FILE_UPLOAD: 'file_upload',
  LANDING_PAGE: 'landing_page',
  SIGNATURE: 'signature'
}

export const usageCount = {
  SUBMISSIONS: 'submission',
  FORMS: 'form',
  FILE_UPLOAD: 'fileUploadStorage',
  LANDING_PAGE: 'landingPage'
}
